// import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import "../Styles/Header.css";
// import { FaSearch } from "react-icons/fa";
// import { IoMdClose } from "react-icons/io";
// import { RiMenu4Fill } from "react-icons/ri";
// import logoImg from "../assets/Header-Images/logo.png";
// import grassImg from "../assets/Header-Images/grassImg.png";
// import { FaPhoneVolume } from "react-icons/fa6";
// import { HiOutlineMailOpen } from "react-icons/hi";
// import { useTranslation } from "react-i18next";

// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const { t, i18n } = useTranslation();
//   const location = useLocation();

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleMenuToggle = () => {
//     setMenuOpen((prev) => !prev);
//   };


//   const handleMouseLeave = () => {
//     setMenuOpen(false);
//   };

//   return (
//     <>
//       <header className={`header ${menuOpen ? "hide-header" : ""}`}>
//         <div className="container">
//           {/* Logo */}
//           <div className="logo">
//             <Link to="/">
//               <img src={logoImg} alt="GICS Logo" className="logo-icon" />
//             </Link>
//             <span className="logo-text">GICS</span>
//           </div>

//           {/* Desktop Navigation */}
//           {!isMobile && (
//             <nav className="nav">
//               <ul className="nav-links">
//                 <li>
//                   <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>
//                     {t("home")}
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/about" className={`nav-link ${location.pathname === "/about" ? "active" : ""}`}>
//                     {t("about")}
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/products" className={`nav-link ${location.pathname === "/products" ? "active" : ""}`}>
//                     {/* Products ▼ */}
//                     {t("products")}
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/Founders" className={`nav-link ${location.pathname === "/Founders" ? "active" : ""}`}>
//                     {t("founders")}
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/blogs" className={`nav-link ${location.pathname === "/blogs" ? "active" : ""}`}>
//                     {t("blog")}
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/contact" className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}>
//                     {t("contact")}
//                   </Link>
//                 </li>
//               </ul>
//             </nav>
//           )}

//           {/* Icons */}
//           <div className="icons">
//             <FaSearch className="icon search-icon" style={{ color: "#4BAF47", fontSize: "28px", fontWeight: "500" }} />
//               {/* Language Selector */}
//               <select
//               className="language-selector"
//               onChange={(e) => i18n.changeLanguage(e.target.value)}
//               value={i18n.language}
//             >
//               <option value="en">English</option>
//               <option value="hi">हिन्दी</option>
//             </select>
//             <button className="menu-toggle" onClick={handleMenuToggle}>
//               <RiMenu4Fill color="green" style={{ color: "#4BAF47", fontSize: "34px", fontWeight: "500" }} />
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Mobile Navigation */}
//       {isMobile && menuOpen && (
//         <div className="mobile-nav">
//           <IoMdClose className="close-icon" onClick={handleMouseLeave} />
//           <ul className="mobile-nav-links">
//             <li>
//               <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`} onClick={handleMenuToggle}>
//                 {t("home")}
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} onClick={handleMenuToggle}>
//                 {t("about")}
//               </Link>
//             </li>
//             <li>
//               <Link to="/products" className={`nav-link ${location.pathname === "/products" ? "active" : ""}`} onClick={handleMenuToggle}>
//                 {t("products ▼")}
//               </Link>
//             </li>
//             {/* Founders link sirf Mobile Navigation ke liye */}
//             <li>
//               <Link to="/founders" className={`nav-link ${location.pathname === "/founders" ? "active" : ""}`} onClick={handleMenuToggle}>
//               {t("founders")}
//               </Link>
//             </li>
//             <li>
//               <Link to="/blogs" className={`nav-link ${location.pathname === "/blogs" ? "active" : ""}`} onClick={handleMenuToggle}>
//                 {t("blog")}
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`} onClick={handleMenuToggle}>
//                 {t("contact")}
//               </Link>
//             </li>
//           </ul>
//           <div className="grass-container">
//             <img src={grassImg} alt="Grass" className="grass-image" />
//           </div>

//           <div className="contact-section">
//             <a href="tel:+91 9826273330" className="contact-link">
//               <FaPhoneVolume size={34} style={{ color: "#4BAF47" }} /> +91 9826273330
//             </a>
//             <a href="mailto:info@example.com" className="contact-link">
//               <HiOutlineMailOpen size={34} style={{ color: "#4BAF47" }} /> globecrop@gmail.com
//             </a>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Header;



import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Styles/Header.css";
import { IoMdClose } from "react-icons/io";
import { RiMenu4Fill } from "react-icons/ri";
import logoImg from "../assets/Header-Images/gics_newlogo.png";
import grassImg from "../assets/Header-Images/grassImg.png";
import { FaPhoneVolume } from "react-icons/fa6";
import { HiOutlineMailOpen } from "react-icons/hi";
import { useTranslation } from "react-i18next";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // Category data
  const categories = [
    {
      id: 1,
      title: "Herbicides",
      icon: "🌿",
      description:
        "Weeds are unwanted plants. Herbicides kill or inhibit their growth.",
    },
    {
      id: 2,
      title: "Fungicides",
      icon: "🧫",
      description:
        "Fungi, bacteria, and viruses harm plants. Fungicides help prevent and combat them.",
    },
    {
      id: 3,
      title: "Insecticides/Pesticides",
      icon: "🐞",
      description:
        "Insecticides, acaricides, and rodenticides help control pests and increase productivity.",
    },
    {
      id: 4,
      title: "Spreaders/Activators",
      icon: "🌱",
      description:
        "Spreaders and activators enhance the absorption and effectiveness of agrochemicals by improving coverage and penetration.",
    },
    {
      id: 5,
      title: "Plant Growth Promoter",
      icon: "🌾",
      description:
        "Plant growth promoters stimulate and regulate plant growth, improving yield, health, and overall productivity.",
    },
    {
      id: 6,
      title: "Liquid water soluble",
      icon: "💧",
      description:
        "100% water-soluble fertilizers for fertigation and foliar application.",
    },
  ];
;
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };


  const handleMouseLeave = () => {
    setMenuOpen(false);
  };

  const handleCategoryClick = (category) => {
    // console.log(category,'category')
    navigate(`/products/${encodeURIComponent(category.title)}`);
    setDropdownOpen(false);
    setMobileDropdownOpen(false);
    setMenuOpen(false);
  };
  

  return (
    <>
      <header className={`header ${menuOpen ? "hide-header" : ""}`}>
        <div className="container">
          {/* Logo */}
          <div className="logo">
            <Link to="/">
              <img src={logoImg} alt="GICS Logo" className="logo-icon" />
            </Link>
            {/* <span className="logo-text">GICS</span> */}
          </div>

          {/* Desktop Navigation */}
          {!isMobile && (
            <nav className="nav">
              <ul className="nav-links">
                <li>
                  <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>
                    {t("home")}
                  </Link>
                </li>
                <li>
                  <Link to="/aboutus" className={`nav-link ${location.pathname === "/aboutus" ? "active" : ""}`}>
                    {t("about")}
                  </Link>
                </li>
                <li
                  className="nav-item"
                  onMouseEnter={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
                >
                  <span className="nav-link">{t("products")}</span>
                  {dropdownOpen && (
                    <div className="dropdown">
                      {categories.map((category) => (
                        <div
                          key={category.id}
                          className={`dropdown-item ${hoveredCategory === category.name ? "hovered" : ""}`}
                          onClick={() => handleCategoryClick(category)}
                          onMouseEnter={() => setHoveredCategory(category.name)}
                          onMouseLeave={() => setHoveredCategory(null)}
                        >
                          {/* Icon and Text */}
                          <div className="category-icon">{category.icon}</div>
                          <div className="dropdown-texts">
                            <span className="dropdown-title">{category.title}</span>
                            <span className="dropdown-text">{category.description}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </li>


                <li>
                  <Link to="/Founders" className={`nav-link ${location.pathname === "/Founders" ? "active" : ""}`}>
                    {t("founders")}
                  </Link>
                </li>
                <li>
                  <Link to="/blogs" className={`nav-link ${location.pathname === "/blogs" ? "active" : ""}`}>
                    {t("blog")}
                  </Link>
                </li>
                <li>
                  <Link to="/testimonials" className={`nav-link ${location.pathname === "/testimonials" ? "active" : ""}`}>
                    {t("testimonials")}
                  </Link>
                </li>
                <li>
                  <Link to="/contactus" className={`nav-link ${location.pathname === "/contactus" ? "active" : ""}`}>
                    {t("contact")}
                  </Link>
                </li>
              </ul>
            </nav>
          )}

          {/* Icons */}
          <div className="icons">
            {/* <FaSearch className="icon search-icon" style={{ color: "#4BAF47", fontSize: "28px", fontWeight: "500" }} /> */}
            {/* Language Selector */}
            <select
              className="language-selector"
              onChange={(e) => i18n.changeLanguage(e.target.value)}
              value={i18n.language}
            >
              <option value="en">English</option>
              <option value="hi">हिन्दी</option>
            </select>
            <button className="menu-toggle" onClick={handleMenuToggle}>
              <RiMenu4Fill color="green" style={{ color: "#4BAF47", fontSize: "34px", fontWeight: "500" }} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Navigation */}
      {isMobile && menuOpen && (
        <div className="mobile-nav">
          <IoMdClose className="close-icon" onClick={handleMouseLeave} />
          <ul className="mobile-nav-links">
            <li>
              <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`} onClick={handleMenuToggle}>
                {t("home")}
              </Link>
            </li>
            <li>
              <Link to="/aboutusTwo" className={`nav-link ${location.pathname === "/aboutusTwo" ? "active" : ""}`} onClick={handleMenuToggle}>
                {t("about")}
              </Link>
            </li>
            <li>
              <span className="nav-link" onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}>
                {t("products")}
              </span>
              {mobileDropdownOpen && (
                <div className="mobile-dropdown">
                  {categories.map((category) => (
                    <div
                      key={category.id}
                      className="dropdown-item"
                      onClick={() => handleCategoryClick(category)}
                    >
                      <div className="category-icon">{category.icon}</div>
                      <div className="dropdown-texts">
                        <span className="dropdown-title">{category.title}</span>
                        <span className="dropdown-text">{category.description}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </li>
            {/* Founders link sirf Mobile Navigation ke liye */}
            <li>
              <Link to="/founders" className={`nav-link ${location.pathname === "/founders" ? "active" : ""}`} onClick={handleMenuToggle}>
                {t("founders")}
              </Link>
            </li>
            <li>
              <Link to="/blogs" className={`nav-link ${location.pathname === "/blogs" ? "active" : ""}`} onClick={handleMenuToggle}>
                {t("blog")}
              </Link>
            </li>
            <li>
              <Link to="/testimonials" className={`nav-link ${location.pathname === "/testimonials" ? "active" : ""}`} onClick={handleMenuToggle}>
                {t("testimonials")}
              </Link>
            </li>
            <li>
              <Link to="/contact" className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`} onClick={handleMenuToggle}>
                {t("contact")}
              </Link>
            </li>
          </ul>
          <div className="grass-container">
            <img src={grassImg} alt="Grass" className="grass-image" />
          </div>

          <div className="contact-section">
            <a href="tel:+91 9826273330" className="contact-link">
              <FaPhoneVolume size={34} style={{ color: "#4BAF47" }} /> +91 9826273330
            </a>
            <a href="mailto:info@example.com" className="contact-link">
              <HiOutlineMailOpen size={34} style={{ color: "#4BAF47" }} /> globecrop@gmail.com
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
